<div>
    <button class="hiddenButton" ></button>
        <div *ngIf="!importOrcidFromOtherPersons && importMyOrcid">
            <br>
            <div *ngIf="!myOrcidIds?.length">
                {{  'fs.res.publication.import.orcid.noId' | hisUi}}
                <a href="../../rds?state=redirect&amp;auth=orcid&amp;action=link&amp;asi={{hisAuthService.asi}}">{{'fs.res.publication.import.orcid.registerId' | hisUi }}</a>
              </div>
            <div *ngIf="myOrcidIds?.length">
                <a href="../../rds?state=redirect&amp;auth=orcid&amp;action=link&amp;asi={{hisAuthService.asi}}">{{'fs.res.publication.import.orcid.registerAnotherId' | hisUi }}</a>
            </div>
            <his-plam *ngIf="myOrcidIdsFiltered?.length">
                <p-autoComplete #content [dropdown]="true" [forceSelection]="true" class="inputWidth100" hisDdKey="fs.res.publication.import.personIdentifier"
                    [(ngModel)]="importRun.importSource" [suggestions]="myOrcidIdsFiltered" (completeMethod)="filterSuggestions($event)">
                </p-autoComplete>
            </his-plam>
        </div>
        <div *ngIf="importOrcidFromOtherPersons">
            <res-publication-search-orcid-user-form
                #orcidUserForm
                [hidden]="!displaySearchForm"
                (submitSearch)="displayResults($event)"
            ></res-publication-search-orcid-user-form>
            <res-publication-search-orcid-user-result
                *ngIf="displaySearchResults"
                [search]="search"
                (changeSearch)="displaySearch(false)"
                (newSearch)="displaySearch(true);"
                (doImport)="doImport($event)"
            ></res-publication-search-orcid-user-result>
        </div>
        <div class="clearer"></div>
        <div *ngIf="!importOrcidFromOtherPersons && importMyOrcid">
            <button [disabled]="!this.importRun.importSource" (click)="doImport()" hisImage="LINE_OUT" class="transparent"><span>{{'fs.res.publication.import.start' | hisUi}}</span></button>
        </div>
</div>
